export class  ProfileType  {
  constructor(public displayName: string, public givenName: string, public userPrincipalName: string) {}
}

export interface IProfileType  {
  displayName?: string;
  givenName?: string;
  userPrincipalName?: string;
}